export default __webpack_public_path__ + "static/media/ic-sites-list.1ab142a6.svg";